




















































































import { mapActions } from 'vuex';

import ErrorAlert from '../common/ErrorAlert.vue';
import DragDropFileInput from '../common/DragDropFileInput.vue';
import { ErrorManager } from '@/models/error';

import FormRules from '@/mixins/file-upload-rules';
import ALDialog from '../core/Dialog/ALDialog.vue';

import mixins from '@/utils/mixins';
import { ALForm } from '@/common/component.types';

const baseMixins = mixins(FormRules);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'CustomerUploadItem',

    components: { DragDropFileInput, ErrorAlert, ALDialog },

    data: () => ({
      dialog: false,
      loading: false,

      percentage: null as null | number,
      file_upload: null as any,

      errorMessage: '',
      detailErrorMessage: '',

      isFileValid: false
    }),

    watch: {
      dialog(value: boolean) {
        if (!value) {
          this.file_upload = null;
        }
      }
    },
    methods: {
      ...mapActions({
        uploadCustomer: 'customer/uploadCustomer'
      }),

      clearAllErrors(): void {
        this.errorMessage = '';
        this.detailErrorMessage = '';
      },

      setForm: function(payload: any) {
        const data = new FormData();
        data.append('file_upload', payload);
        return data;
      },

      resetFormValidation(): void {
        if (this.$refs.form) {
          return this.$refs.form.resetValidation();
        }
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      uploadFile(): any {
        if (this.validateForm()) {
          this.loading = true;

          this.clearAllErrors();
          return this.uploadCustomer(this.setForm(this.file_upload))
            .then(res => {
              this.$emit('passed', res);
              this.file_upload = null;
              this.close();
            })
            .catch(error => {
              if (error.response) {
                if (error.response.data.detail) {
                  this.detailErrorMessage = error.response.data.detail;
                }
              }
              this.errorMessage = ErrorManager.extractApiError(error);
              this.$emit('failed', error);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      },

      close() {
        this.dialog = false;
        this.clearAllErrors();
        this.resetFormValidation();
      }
    }
  });
